import LabelFooter from 'components/common/Chart/LabelFooter';
import FilterThiTruong from 'components/common/FilterThiTruong';
import Highcharts from 'highcharts'
import HighchartsReact from 'highcharts-react-official'
import useGrowth from 'hook/useGrowth';
import useHelper from 'hook/useHelper';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import API from 'service/API';

import './LeftGrowth.scss'
import { options } from './LeftGrowthConfig';

export default function LeftGrowth() {
  const CommnonStore = useSelector((state: any) => state?.CommnonStore)
  const StocksAnalysisStore = useSelector((state: any) => state?.StocksAnalysisStore);
  const GrowthStore = useSelector((state: any) => state?.GrowthStore);
  const [filter, setFilter] = useState({ cycle: 'Q', ticker: '' })
  const [FilterLabel, setFilterLabel] = useState<any>([])
  const { fetchDataGrowth, filterDataGrowth } = useGrowth();
  const { handleFilterArray } = useHelper();

  useEffect(() => {
    if (StocksAnalysisStore?.inputSearch) {
      setFilter({ ...filter, ticker: StocksAnalysisStore?.inputSearch })
    }
  }, [StocksAnalysisStore?.inputSearch])

  useEffect(() => {
    fetchDataGrowth(filter)
  }, [filter])

  const handleChangeFilterLabel = (value: string) => {
    const FilterLabelNew: any = handleFilterArray(value, FilterLabel)
    setFilterLabel([...FilterLabelNew])
  }

  const handleChangeFilter = (value: string) => {
    setFilter({ ...filter, cycle: value })
  }

  return (
    <>
      <div className='jisdpacqsr'>
        <FilterThiTruong setSelectOption={(value: any) => handleChangeFilter(value)} defaultData={filter?.cycle} data={[
          { name: 'Quý', value: 'Q' },
          { name: 'Năm', value: 'Y' },
        ]} />
        <div className='xvWLpciTMw'>
          <div className='yatjyujogr'>Kết quả kinh doanh</div>
          <div className='bcfualfcnb'>Tăng trưởng</div>
          <HighchartsReact
            highcharts={Highcharts}
            options={options(filterDataGrowth(GrowthStore?.GrowthAnalysis, filter), CommnonStore, FilterLabel)}
          />
        </div>
        <LabelFooter selectData={(value: string) => handleChangeFilterLabel(value)}
          listDefault={FilterLabel}
          data={[
            { name: 'Doanh thu thuần', color: '#22AB24' },
            { name: 'Lợi nhuận gộp', color: '#B8B8B8' },
            { name: 'Lợi nhuận sau thuế', color: '#F2994A' },
            { name: 'Tăng trưởng DTT', color: '#E31E4D' },
          ]} />
      </div>
    </>
  )
}